import "./UseCase.scss";
import { useCallback, useState } from "react";


const options = [
  {
    url: "https://www.youtube.com/embed/ZQYIV7h42zg",
    title: "EducUp demo integration with OC-ID Connect",
    description:
      "See how EducUp integrates with OC-ID Connect to provide seamless educational experiences",
  },
  {
    url: "https://www.youtube.com/embed/1BZNaANBrE8",
    title: "Mancer.work demo integration OC-ID Connect",
    description:
      "Discover how Mancer.work leverages OC-ID Connect for verified credentials in the job marketplace",
  },
  {
    url: "https://www.youtube.com/embed/W3ui3rXWr1A",
    title: "NearX demo integration with OC-ID Connect",
    description:
      "Learn how NearX integrates with OC-ID Connect to enhance user verification",
  },
  {
    url: "https://www.youtube.com/embed/PZDKxRSNQgg",
    title: "Zydii demo integration with OC-ID Connect",
    description:
      "Watch Zydii's implementation of OC-ID Connect for improved learning experiences",
  },
  {
    url: "https://www.youtube.com/embed/xqSP2zgEKV4",
    title: "BAG demo integration with OC Achievements",
    description:
      "See how BAG utilizes OC Achievements to verify and showcase educational credentials",
  },
  {
    url: "https://www.youtube.com/embed/FXs1hskWu0A",
    title: "EducUp demo integration with OC Achievements",
    description:
      "Explore EducUp's integration with OC Achievements for verifiable learning accomplishments",
  },
  {
    url: "https://www.youtube.com/embed/is1Q99tOiTI",
    title: "Mancer.work demo integration with OC Achievements",
    description:
      "Discover how Mancer.work uses OC Achievements to verify skills and credentials",
  },
  {
    url: "https://www.youtube.com/embed/DjrMDwoQkZ8",
    title: "NearX demo integration with OC Achievements",
    description:
      "Learn how NearX implements OC Achievements for verified on-chain credentials",
  },
  {
    url: "https://www.youtube.com/embed/B0aQlsjWCM0",
    title: "Zydii demo integration with OC Achievements",
    description:
      "Watch how Zydii integrates with OC Achievements to enhance their educational platform",
  },
];

const UseCase = ({}) => {
  const [selected, setSelected] = useState(options[0].url);

  const handleChangeUrl = useCallback((event, url) => {
    event.stopPropagation();
    event.preventDefault();

    setSelected(url);
  }, []);

  return (
    <div className="usecase-paper-root">
      <div className="container">
        <span className="usecase-title">Use cases</span>
        <span className="usecase-subtitle mt-20">
          OC Achievements can transform education, from streamlining admissions
          and facilitating credit transfers to offering skill certifications and
          incentivizing learning. Explore how verified credentials empower
          learners, educators, and institutions across the Web3 ecosystem.
        </span>
        <iframe
          className={"usecase-player"}
          key={Math.random()}
          src={selected}
          title=""
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
        <div className={"usecase-playlist"}>
          {options.map((item, idx) => (
            <div
              key={idx}
              className={"flex items-center"}
              onClick={(event) => handleChangeUrl(event, item.url)}
            >
              <div className={"relative flex"}>
                <iframe
                  src={item.url}
                  className={"usecase-playlist-icon"}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                />
                {selected === item.url && (
                  <div
                    className={
                      "usecase-overlay flex justify-center items-center"
                    }
                  >
                    <span className={"usecase-playlist-text"}>Playing</span>
                  </div>
                )}
              </div>
              <div className={"flex-1 ml-30 flex flex-col"}>
                <span className={"usecase-playlist-title mb-10"}>
                  {item.title}
                </span>
                <span className={"usecase-playlist-subtitle"}>
                  {item.description}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default UseCase;
